(function() {
    'use strict';
    angular
        .module('jotApp')
        .factory('TabProperties', TabProperties);

    TabProperties.$inject = ['$resource'];

    function TabProperties ($resource) {
        var resourceUrl =  'api/tab-properties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
